import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";

const documentPropertiesReducer = (state = initialState.document.documentProperties, action) => {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_PROPERTIES_SUCCESS: {
      return {
        ...state,
        [action.id]: {
          loaded: true
        }
      };
    }
    case actionTypes.LOAD_DOCUMENT_PROPERTIES_STARTED: {
      return {
        ...state,
        [action.id]: {
          loaded: false
        }
      };
    }
    case actionTypes.LOAD_DOCUMENT_PROPERTIES_FAILED: {
      return {
        ...state,
        [action.id]: {
          loaded: false
        }
      };
    }
    case eventTypes.DOCUMENT_PROPERTIES_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          loaded: false
        }
      };
    }
    default:
      return state;
  }
};

export default documentPropertiesReducer;
